export default function Flame({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 9.44218C13 13.6162 9.93812 17 6.16111 17C2.3841 17 -0.677859 14.8597 0.130459 10.7667C0.690007 7.93333 7.52889 7.69807 6.845 0.140253C6.7401 -1.01906 13 5.26811 13 9.44218Z"
        fill="currentColor"
      />
      <path
        d="M3.3599 9.52874C4.18378 11.8417 6.18291 13.2426 7.82508 12.6576C9.46725 12.0727 10.3761 10.4125 9.21674 8.26959C8.41422 6.78621 5.39437 7.71497 4.19994 3.42103C4.01673 2.76237 2.53602 7.21575 3.3599 9.52874Z"
        fill="currentColor"
      />
      <path
        d="M10 11.888C10 13.6067 8.82236 15 7.36966 15C5.91696 15 4.73928 14.1187 5.05018 12.4333C5.26539 11.2667 7.89573 11.1698 7.63269 8.05775C7.59235 7.58039 10 10.1692 10 11.888Z"
        fill="currentColor"
      />
    </svg>
  )
}
